import { render, staticRenderFns } from "./optionAnswer.vue?vue&type=template&id=51110db6&scoped=true&"
import script from "./optionAnswer.vue?vue&type=script&lang=js&"
export * from "./optionAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51110db6",
  null
  
)

export default component.exports